import React from 'react';
import { Link } from 'react-router-dom'; // Import for using Link component


import './BillingBreadcrumb.css';

function BillingBreadcrumb({ items , setbillingcontext}) {

    const handleSetBillingContextFunc = setbillingcontext;

  const handleClick = (index) => {
    console.log('Clicked item:', index); // Example usage

    handleSetBillingContextFunc(index);
  };

  if (!items || items.length === 0) {
    return null; // Or return a message indicating no breadcrumbs
  }

  return (
    <nav aria-label="Breadcrumb">
      <ol className="breadcrumb">
        {items.map((item, index) => {
          const isLastItem = index === items.length - 1;

          return (
            <li key={index} className="breadcrumb-item" onClick={() => handleClick(index)}>
              {isLastItem ? (
                <span className="breadcrumb-text">{item.title}</span>
              ) : (
                //<Link to={item.path} className="breadcrumb-text">
                  //{item.title}
                //</Link>
                //<div onClick={handleClick}> // Attach the onClick handler
                //<span className="breadcrumb-text">{item.title}</span>
                //</div>

                <span className="breadcrumb-text"><Link to={item.path}>{item.title}</Link></span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default BillingBreadcrumb;
